import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'

const api = axios.create({
  baseURL: process.env.VUE_APP_BASEAPI,
})

axios.defaults.withCredentials = true

// 成功处理函数
const successHandle = async res => {
  let msg = res.data.msg
  if (!res.data.code) return res.data 
  switch (res.data.code) {
    case 0:
    case 1: // 该手机号已注册
      return res.data
    default:
      Message.error(msg || '服务异常请稍后重试！')
      return Promise.reject(res)
  }
}

// request的拦截器对象
api.interceptors.request.use(
  config => {
    const { token, lang } = store.state || {}
    if (token) {
      config.headers.Authorization = token
    }
    config.headers['Accept-Language'] = lang
    config.headers['channel'] = '60'
    return config
  },
  err => {
    Promise.reject(err)
  }
)

// response的拦截器对象
api.interceptors.response.use(
  res => {
    if (res.request.responseType && res.request.responseType === 'blob') {
      return res
    }
    return successHandle(res)
  },
  err => {
    return Promise.reject({
      msg: err,
      code: 7870,
    })
  }
)

export default api
